import * as react from "react";

export const getDefaultProps = {
    axis: void 0,
    bounds: void 0,
    cancel: void 0,
    children: react.createElement(react.Fragment, {}),
    defaultClassName: void 0,
    defaultClassNameDragged: void 0,
    defaultClassNameDragging: void 0,
    defaultPosition: void 0,
    disabled: void 0,
    grid: void 0,
    handle: void 0,
    nodeRef: void 0,
    offsetParent: void 0,
    onDrag: void 0,
    onMouseDown: void 0,
    onStart: void 0,
    onStop: void 0,
    position: void 0,
    positionOffset: void 0,
    scale: void 0,
};

export function Draggable(props) {
    return null;
}

